import * as React from "react";
import { IEditButtonProps } from ".";
import { Button } from "./EditButton.styles";

export const EditButton: React.FunctionComponent<IEditButtonProps> =
    ({ Caption, OnClick }: IEditButtonProps) => {
        const [IsHovering, SetIsHovering] = React.useState<boolean>(false);
        return (
            <Button
                type="button"
                onClick={OnClick}
                onMouseEnter={() => SetIsHovering(true)}
                onMouseLeave={() => SetIsHovering(false)}
                IsHovering={IsHovering}
            >
                {Caption}
            </Button>
        );
    };
